import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const IntermittentFastingPage: FC = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string>("");

  const options = [
    "Yes — I follow a fasting window",
    "Sometimes / Not sure",
    "No — I eat throughout the day",
  ];

  const handleNext = () => {
    if (!selected) {
      return;
    }

    // Convert to Django choice values (second value in tuple)
    let backendValue;
    if (selected === "Yes — I follow a fasting window") {
      backendValue = "yes_fasting_window";
    } else if (selected === "Sometimes / Not sure") {
      backendValue = "sometimes_not_sure";
    } else {
      backendValue = "no_eat_throughout_day";
    }

    SessionStorageHelper.saveField("intermittent_fasting", backendValue);

    if (selected === "Yes — I follow a fasting window") {
      navigate("/glucera" + GluceraNavigationRoutes.eatingwindowpage);
    } else {
      // If Sometimes or No, clear any existing fasting_window_type
      SessionStorageHelper.saveField("fasting_window_type", null);
      navigate("/glucera" + GluceraNavigationRoutes.ASSESSMENT_SUMMARY);
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 10 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-6 py-2">
          <div className="mb-8 space-y-2">
            <h1 className="text-large-title font-bold text-foreground sm:text-4xl">
              Are You Currently Following Intermittent Fasting?
            </h1>
          </div>

          <div className="space-y-3">
            {options.map(option => (
              <Card
                key={option}
                onClick={() => setSelected(option)}
                className={`cursor-pointer p-4 transition-all hover:shadow-md ${
                  selected === option
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <RadioDot selected={selected === option} />
                  <span className="flex-1 text-callout font-medium text-foreground">
                    {option}
                  </span>
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container */}
          <div className="mt-auto pt-4">
            <Button
              onClick={handleNext}
              disabled={!selected}
              className={gluceraAssessmentCta}
            >
              {selected ? "Next" : "Select Option"}
            </Button>
          </div>
        </div>

        {/* Safe area padding */}
        <div className="pb-safe p-2" />
      </div>
    </div>
  );
};

export default IntermittentFastingPage;
